module.exports = __webpack_public_path__ + "img/deskshelf02.eedbf0a5.jpg";